import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Button } from "@ts-digital/vrc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { faChevronDoubleUp, faLevelUpAlt } from "@fortawesome/pro-regular-svg-icons";
import moment from "moment";
import { FormattedMessage } from "react-intl";
import { Tooltip } from "antd";
import {
  deleteSingleNotification,
  updateSingleNotification
} from "../../../../store/actions/ncs/write";
import "./style.css";

const priorityIcon = priority => {
  switch (priority) {
  case "MEDIUM":
    return faLevelUpAlt;
  case "HIGH":
  default:
    return faChevronDoubleUp;
  }
};

const SingleNotification = ({
  auth,
  user,
  title,
  message,
  date,
  note,
  priority = "LOW",
  read,
  id
}) => {
  const dispatchAction = useDispatch();
  let today = moment.utc();
  const formattedDate = today.diff(date, "days") > 2 ? moment(date).format("D MMM YYYY") : moment(date).fromNow();

  const readTooltipId = read ? "notification.markAsUnread" : "notification.markAsRead";

  const updateReadNotification = (notificationId, request) => {
    if (user.profile.ncsId)
      dispatchAction(updateSingleNotification(
        auth.loginAuth, user.profile.ncsId, notificationId, request
      ));
  };

  const deleteNotification = (notificationId) => {
    if (user.profile.ncsId)
      dispatchAction(deleteSingleNotification(
        auth.loginAuth, user.profile.ncsId, notificationId
      ));
  };

  return (
    <div className={"single-notification" + (priority === "HIGH" ? " priority-high" : "") + (read ? " read" : "")}>
      <div className="single-notification-content">
        <div className="single-notification-avatar">TSD</div>
        <div>
          <div className="single-notification-title">{title}</div>
          <div className="single-notification-message">{message}</div>
        </div>
        <div>
          <div className="single-notification-remove-button">
            <Tooltip 
              color={"rgb(0, 80, 117)"}
              placement="left" title={<FormattedMessage id="notification.remove" />}>
              <Button kind="tertiary" size="small" onClick={() => deleteNotification(id)}>
                <FontAwesomeIcon icon={faTimes} />
              </Button>
            </Tooltip>
          </div>
        </div>
        <div className="single-notification-proprity-container">
          {priority !== "LOW" && <FontAwesomeIcon icon={priorityIcon(priority)} />}
        </div>
        <div className="single-notification-date">{formattedDate}</div>
        <Tooltip 
          color={"rgb(0, 80, 117)"}
          placement="left" 
          title={<FormattedMessage id={readTooltipId} />}>
          <Button
            kind="tertiary"
            size="small"
            onClick={() => {
              updateReadNotification(id, { read: !read });
            }}
          >
            <div className={"single-notification-red-flag" + (read ? " read" : "")}></div>
          </Button>
        </Tooltip>
        {note && (
          <React.Fragment>
            <div className="single-notification-notelabel">
              <FormattedMessage id="general.note" />
            </div>
            <div className="single-notification-note">{note}</div>
          </React.Fragment>
        )}

      </div>
    </div>
  );
};

SingleNotification.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  date: PropTypes.string,
  note: PropTypes.string,
  priority: PropTypes.oneOf(["LOW", "MEDIUM", "HIGH"]),
  read: PropTypes.bool,
  deleteSingleNotification: PropTypes.func,
  updateSingleNotification: PropTypes.func
};

export default SingleNotification;
